module.exports = {
    NAV_BAR_HEIGHT: 72
};
